import React, { useState } from "react";
import LinkSidePannelMenu from "../common/LinkSidePannelMenu";
import { IInfoStep } from "../../context/model";
import useAppState from "../../context/AppContext";
import { NavLink, useLocation } from "react-router-dom";
import { hasLockMode, isDisabledStep } from "../../utils/dataUtils";
import { handleKeyDown } from "../../utils/utils";

interface MenuItemProps {
  label: string;
  name: string;
  subMenuItems?: IInfoStep[] | null;
  path: string;
  state?: string
}

const MenuREItem: React.FC<MenuItemProps> = ({ label, name, subMenuItems, path, state }) => {
  
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);

  const {
    state: {infoSteps, proposition, isRetired},
  } = useAppState();

  const currentLocation = useLocation();
 
  const getState = () => {
    if (state) {
      return state === 'conseiller-active' && path === currentLocation.pathname ? "active" : state;
    }

    if (hasLockMode(proposition?.stateCode, name)) {
      return "completed";
    }

    const steps = subMenuItems || infoSteps.filter(e => e.category === name);
    const isPathCurrentLocation = (step: any) => step.path === currentLocation.pathname;
    const isStepInactive = (step: any) => step.state === "INACTIVE";
      if (!steps.some(isStepInactive) && !steps.some(isPathCurrentLocation)) {
        return "completed";
      } else if (currentLocation?.pathname === '/retired-collectif/finaliser') {
        return "completed";
      }else if (steps.some(isPathCurrentLocation)) {
        return "active";
      } 
    
    return "disable";
  };
  
  const categoryState = getState();

  const getCurrentStep = () => {
    const steps =subMenuItems  || infoSteps.filter(e => e.category === name);
    const index = steps.findIndex(step => step.path === currentLocation.pathname);
    return `${index + 1}/${steps.length}`
  }

  const handleSubMenuClick = () => {
    if (!hasLockMode(proposition?.stateCode, name)) {
      if ( categoryState === "active" || categoryState === "completed") {
        setIsSubMenuOpen(!isSubMenuOpen);
      }
    }
  };

  const disableCategory =
    (proposition?.stateCode === 1 && 
    (categoryState=== 'completed' || categoryState === 'disable') && 
    isRetired) 
        ? 'not-allowed inactive' 
        : 
        '';

  console.log('subMenuItems', subMenuItems)

  return (
    <>
      {
        subMenuItems ? 
        <div className="alert alert-bleu m-x-md mt-lg" style={{padding: '0'}}> 
          <div className={`alert--title p-sm menu ${categoryState} ${categoryState === "active" ? 'category-active' : 'pr-0'}`} onClick={handleSubMenuClick} role="button" tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}> 
              <p className="sc-appear-fromleft delay-1  isreveal">{label}</p>
              {categoryState === "active" && <div className="step-badge">{getCurrentStep()}</div>}
              {categoryState ==="completed" && <i className="icon-check fz-xs bleu-clair" />}
          </div>
          
          {
            (categoryState ==="active" || isSubMenuOpen) && 
            subMenuItems &&
            <nav className="lateralnav">
              <ul>
                  {subMenuItems.map((step, i) => (
                    !step.menuHide&&<LinkSidePannelMenu menuPathUrl={step.path} menuIndex={i + 1} menuLabel={step.label} key={i} disabled={isDisabledStep(proposition!,step)}/>
                  ))}
              </ul>
            </nav>
          }
        </div> 
        :
        <div className={`alert alert-bleu m-x-md mt-lg ${disableCategory}`} style={{padding: '0'}}> 
            <div className={`lateralnav ${disableCategory}`}>
                <div className={`lateralnav--item ${categoryState} custom ${disableCategory}`}>
                    {proposition?.stateCode !== 1 &&
                        <NavLink to={categoryState === "disable" || hasLockMode(proposition?.stateCode, name) ? '#' : path} className={`alert--title menu`} onClick={handleSubMenuClick}>
                            <p className="sc-appear-fromleft delay-1 isreveal">{label}</p>
                            {categoryState ==="completed" && <i className="icon-check fz-xs bleu-clair" />}
                        </NavLink>
                    }
                    {proposition?.stateCode === 1 &&
                        <NavLink to={'#'} className={`alert--title menu ${disableCategory}`} >
                            <p className={`sc-appear-fromleft delay-1 isreveal ${disableCategory}`}>{label}</p>
                            {(categoryState ==="completed" || categoryState ==='disable') && <i className={`icon-check fz-xs bleu-clair ${disableCategory}`} />}
                        </NavLink>
                    }
                </div>
            </div>
        </div>
    }   
    </> 
  );
};

export default MenuREItem;